import { render, staticRenderFns } from "./AddRunPayroll.vue?vue&type=template&id=23856893&"
import script from "./AddRunPayroll.vue?vue&type=script&lang=js&"
export * from "./AddRunPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports